import groupCampusesByRegion from "../../../../../util/groupCampusesByRegion";
import {CampusesById} from "../../../../../types/Campus";
import {SetCurrentCampuses} from "./CampusSelectorDropdown";
import getOneFromSet from "../../../../../util/getOneFromSet";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot} from "@fortawesome/pro-regular-svg-icons/faLocationDot";
import React from "react";

interface OtherLocationsNearYouProps {
	allCampusesById: CampusesById;
	currentCampuses: Set<string>;
	setCurrentCampuses: SetCurrentCampuses;
}

const getOtherCampusesInRegion = (
	allCampusesById: CampusesById,
	currentCampuses: Set<string>
) => {
	if (currentCampuses.size === 0) {
		return [];
	}
	const campusesByRegion = groupCampusesByRegion(allCampusesById);
	const currentCampus =
		allCampusesById[getOneFromSet(currentCampuses) as string];
	const campusesInRegion = campusesByRegion[currentCampus.region];
	return campusesInRegion.filter(
		(campus) => campus.campusId !== currentCampus.campusId
	);
};

/**
 * Display a clickable list of other campuses in the same region as the current campus.
 */
const OtherLocationsNearYou: React.FC<OtherLocationsNearYouProps> = ({
	allCampusesById,
	currentCampuses,
	setCurrentCampuses,
}) => {
	const otherCampusesInRegion = getOtherCampusesInRegion(
		allCampusesById,
		currentCampuses
	);
	if (otherCampusesInRegion.length === 0) {
		return null;
	}
	return (
		<div className="flex flex-col gap-4 text-center">
			<div>
				Other locations near you:{" "}
				<span className="hidden md:inline">
					{otherCampusesInRegion.map((campus, idx) => (
						<React.Fragment key={campus.campusId}>
							<a
								className="cursor-pointer text-hyperlink"
								onClick={() => setCurrentCampuses(new Set([campus.campusId]))}
							>
								{campus.city}
							</a>
							{idx === otherCampusesInRegion.length - 1 ? "" : ", "}
						</React.Fragment>
					))}
				</span>
			</div>
			<div className="flex flex-col justify-center gap-2 xs:flex-row md:hidden">
				{otherCampusesInRegion.map((campus) => (
					<div key={campus.campusId}>
						<a
							className="inline-flex cursor-pointer items-center gap-2 rounded-full border-1 border-gray-400 bg-gray-50 px-6 py-2 hover:bg-gray-200"
							onClick={() => setCurrentCampuses(new Set([campus.campusId]))}
						>
							<FontAwesomeIcon icon={faLocationDot} /> {campus.city}
						</a>
					</div>
				))}
			</div>
		</div>
	);
};

export default OtherLocationsNearYou;
